import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Sprite from '~components/Sprite'
import { Link } from 'react-router-dom'

class Ribbon extends Component {
  getIcon () {
    const { status } = this.props

    if (status === 'success') {
      return 'tick'
    }

    return 'cross'
  }

  getbgColour () {
    const { status } = this.props

    if (status === 'success') {
      return 'green'
    }

    return 'red'
  }

  render () {
    return (
      <div className={classNames(
        'flex flex-col text-white items-center text-center justify-center p-6 lg:text-left lg:flex-row lg:justify-start xl:p-8',
        `bg-${this.getbgColour()}`,
        this.props.className
      )}
      >
        <span className="w-8 h-8 border-2 fill-current border-white rounded-1/2 flex flex-col mx-auto lg:m-0 flex-shrink-0">
          <span className="w-4 h-4 block m-auto icon icon-fill">
            <Sprite name={this.getIcon()} />
          </span>
        </span>

        {this.props.text && (
          <span className="block mt-4 max-w-1/2 mx-auto lg:mt-0 lg:ml-6 lg:mr-auto lg:max-w-none">
            {this.props.text}
          </span>
        )}

        {this.props.link && (
          <Link to={this.props.link} className="mt-4 text-center block underline hover:no-underline focus:no-underline lg:mt-0 lg:ml-6 flex-shrink-0">
            {this.props.linkText}
          </Link>
        )}
      </div>
    )
  }
}

Ribbon.propTypes = {
  status: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.string,
  linkText: PropTypes.string,
  className: PropTypes.string
}

export default Ribbon
